import { render } from "./MusicPlayer.vue?vue&type=template&id=6f4645b3"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./MusicPlayer.vue?vue&type=custom&index=0&blockType=css&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\trax\\my_blog\\my_blog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__